import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🔥", key: "allIn" },
  { emoji: "🏁", key: "readyToTry" },
  { emoji: "👊", key: "wantToSeeFirst" },
]

export default function CarsCommitmentPage() {
  return <RadioCardListPage translationKey="carsCommitment" options={OPTIONS} />
}
